module.exports = __webpack_public_path__ + "static/media/preview_general_campaign_1.83aa9ed8.svg";